import ArticlePublishDate from './ArticlePublishDate';

export default ArticlePublishDate;
